import React, { useEffect, useState } from 'react';
import apis from '@src/apis';
import { PACKAGE_TYPE } from '@src/constants/package';
import SubscriptionSuggestion from '.';

const MobileSubscriptionSuggestion = () => {
  const packageType = PACKAGE_TYPE.STUDIO;
  const [packages, setPackages] = useState([]);
  const [totalVoucher, setTotalVoucher] = useState([]);

  // Lấy tất cả các gói cước
  const fetchPackages = async () => {
    const pkgQuery = { type: packageType, active: true, purchasable: true };
    const { status, result } = await apis.packages.getPackages(pkgQuery);
    if (status) {
      setPackages(result.packages);
    }
  };

  const fetchTotalVouchers = async () => {
    const data = await apis.vouchers.getVouchers();
    if (data.status) {
      setTotalVoucher(data.result);
    }
  };

  useEffect(() => {
    fetchPackages();
    fetchTotalVouchers();
    return () => {
      setTotalVoucher([]);
    };
  }, []);

  return (
    <SubscriptionSuggestion
      packagesData={packages}
      allVouchers={totalVoucher}
    />
  );
};

export default MobileSubscriptionSuggestion;
